<template>
  <img
    class="brand-logo-image"
    :class="[`brand-logo-image--${preset}`, { 'brand-logo-image--monochrome': monochrome }]"
    :src="source"
    :alt="$branding.logo.alt"
    :style="imageStyle"
    @load="$emit('load', $event)"
    @error="$emit('error', $event)"
  >
</template>

<script>
const presets = {
  document: {},
  navigation: { width: '140px', height: '48px' },
  compact: { width: '38px', height: '38px' },
  auth: { width: '220px', height: '96px' },
}

export default {
  name: 'BrandLogo',
  props: {
    variant: {
      type: String,
      default: 'main',
      validator: value => ['main', 'icon'].includes(value),
    },
    preset: {
      type: String,
      default: 'document',
      validator: value => Object.prototype.hasOwnProperty.call(presets, value),
    },
    monochrome: { type: Boolean, default: false },
  },
  computed: {
    source() {
      return this.$branding.logo[this.variant] || this.$branding.logo.main
    },
    imageStyle() {
      return {
        objectFit: 'contain',
        maxWidth: '100%',
        ...presets[this.preset],
      }
    },
  },
}
</script>

<style lang="scss">
.brand-logo-image {
  vertical-align: middle;
}

.brand-logo-image--monochrome {
  filter: grayscale(1);
}

// A neutral surface keeps the same artwork legible on dark app chrome.
.dark-layout, .menu-dark {
  .brand-logo-image--navigation,
  .brand-logo-image--compact,
  .brand-logo-image--auth {
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
